<template>
	<div>
		<b-card>
			<div slot="header">
				<span style="font-size: 20px; font-weight: bold">{{$t("Тип Расходы")}}</span>
				<div class="card-header-actions">
					<b-button @click="openModal" variant="outline-primary" class="mr-2"><i class="fa fa-plus"/></b-button>
				</div>
			</div>
			<b-row>
				<b-col cols="2">
					<b>Наименование:</b>
				</b-col>
				<b-col cols="4">
					<b-form-input v-model="payload.value" :placeholder="$t('Наименование')"/>
				</b-col>
				<b-col>
<!--					<date-picker v-model="form.expenseDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY"/>-->
				</b-col>
				<b-col>
<!--					<multiselect v-model="form.currencyCode" :options="options"  class="multiselect-pricing" :placeholder="$t('Валюта')"/>-->
				</b-col>
				<b-col cols="1">
					<b-button variant="dark" @click="search">
						<span><i class="fa fa-search"></i></span>
					</b-button>
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-table :items="items" :fields="columns" striped hover show-empty :busy="loading" class="m-4">
					<template slot="id" slot-scope="data">
						{{ paginate(data.index, payload.page, payload.limit) }}
					</template>
				</b-table>
				<b-col cols="12">
					<b-pagination :total-rows="total" :per-page="payload.limit" v-model="payload.page" align="center" aria-controls="table" style="margin: 0 auto"/>
				</b-col>
			</b-row>
			<b-modal v-model="ModalForm" :title="create ? 'Создать' : 'Редактировать'">
				<b-overlay>
					<b-row class="mt-2">
						<b-col cols="4">
							<b>Наименование:</b>
						</b-col>
						<b-col cols="8">
							<b-form-input v-model="form.why" :placeholder="$t('Наименование')"/>
						</b-col>
					</b-row>
					<b-row class="mt-2">
						<b-col cols="4">
							<b>Коммент:</b>
						</b-col>
						<b-col cols="8">
							<b-form-input v-model="form.comment" :placeholder="$t('комментария')"/>
						</b-col>
					</b-row>
				</b-overlay>
				<template #modal-footer>
					<b-row>
						<b-col align="right">
							<b-button @click="ModalForm=false" variant="outline-danger">{{ $t('cancel') }}</b-button>
							<b-button @click="save" variant="success" class="ml-2">{{ $t('save') }}</b-button>
						</b-col>
					</b-row>
				</template>
			</b-modal>
		</b-card>
	</div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { BOverlay } from 'bootstrapVue2';
import ReferencesService from "@/services/references.sevice";
import ReportService from "@/views/analytics/otchot/report.service";
export default {
	name: 'ExpenseCost',
	components: {
		BOverlay,
		Multiselect
	},
	data(){
		return {
			loading: false,
			total: null,
			payload: {
				page: 1,
				limit: 20,
				value: "",
			},
			items: [],
			columns: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'why', label: this.$t('Наименование'), class: 'text-center', sortable: true},
				{key: 'comment', label: this.$t('комментария'), class: 'text-center'},
			],
			list:[],
			form:{},
			options:['UZS','USD'],
			ModalForm:false,
			create:true,
			value:'',
		}
	},
	methods:{
		date(){
			this.form.expenseDate
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		search(){
			this.loading = true
			this.getItems();
		},
		getItems(){
			ReferencesService.getSearchExpenses1(this.payload,).then(res => {
				this.items = res.data.items
				this.total = res.data.total
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		openModal() {
			this.create = true
			this.ModalForm = true
			this.form = {}
		},
		save(){
			if (this.form.why) {
				ReferencesService.getReferenceChildrencreate1(this.form).then(res => {
					this.$vs.notify({
						title: 'Успешно сохранено!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					});
					this.ModalForm = false
					this.getItems();
				}).catch(e => {
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
			else {
				this.$vs.notify({
					title: "заполните все обязательное поля",
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}
		},
	},
	created() {
		this.getItems()
	},
	watch: {
		'payload.page': {
			handler(){
				this.getItems();
			},
			deep: true,
		}
	}
}
</script>
